import { gql } from '@apollo/client'
import { CUBE_DIMENSIONS } from './CubeDimensions'
import { SHELF_SCAN_FRAGMENT } from './ShelfScanFragment'

export const DISPLAY_FRAGMENT = gql`
  fragment Display on Display {
    id
    qrId
    created
    name
    shortDescription
    displayType
    extraInfo
    saved
    isCompetitor
    salesVolume
    images {
      id
      url
    }
    area
    numCoolerDoors
    doorHandlePlacement
    idealInventory {
      upcs
    }
    fixtureType {
      id
      name
    }
    latestRecommendations {
      id
      created
      score
      productRecommendations {
        id
        count
        upc
      }
    }
    point {
      latitude
      longitude
    }
    boundingCubes {
      ...CubeDimensions
    }
    dateRemoved
    movedToDisplay {
      id
    }
    previousAuditUpcs
    needsFieldVerifiedCountsPostScan
    needsFieldVerifiedCountsPreScan
    lastAudited
    merchandisingState
    lastScan {
      created
      complianceScore {
        score
      }
      user {
        firstName
        lastName
      }
      scans {
        shelfScans {
          ...ShelfScan
        }
        keyframes
      }
    }
  }
  ${SHELF_SCAN_FRAGMENT}
  ${CUBE_DIMENSIONS}
`
